import { translation } from '@/features/change-language/lib/i18n'

export const getMainLinks = () => {
  const mainLinks: RouteLink[] = [
    { to: '/devices', key: 'devices', text: translation('menu.devices') },
    { to: '/demo', key: 'demo', text: translation('menu.demo') },
    {
      to: '/projects',
      key: 'projects',
      text: translation('menu.project')
    },
    { to: '/ai', key: 'ai', text: translation('menu.ai') },
    { to: '/usecase', key: 'usecase', text: translation('menu.usecase') }
  ]
  return mainLinks
}

export const getDeviceLinks = () => {
  const deviceLinks: RouteLink[] = [
    { to: '/devices/robots', key: 'devices-robots', text: translation('menu.devices_menu.robot') },
    {
      to: '/devices/cameras',
      key: 'devices-cameras',
      text: translation('menu.devices_menu.camera')
    },
    {
      to: '/devices/video-transmission',
      key: 'devices-video-transmission',
      text: translation('menu.devices_menu.video_transmission')
    },
    {
      to: '/devices/wireless-communication',
      key: 'devices-wireless-communication',
      text: translation('menu.devices_menu.wireless_communication')
    }
  ]
  return deviceLinks
}

export const getDemoLinks = () => {
  const demoLinks: RouteLink[] = [
    {
      to: '/demo/control/puppy-pi',
      key: 'demo-control',
      text: translation('menu.demo_menu.robot'),
      children: [
        { to: '/demo/control/puppy-pi', key: 'demo-control-puppy-pi', text: 'PuppyPi' },
        { to: '/demo/control/spider-pi', key: 'demo-control-spider-pi', text: 'SpiderPi' },
        {
          to: '/demo/control/deep-think-car',
          key: 'demo-control-deep-think-car',
          text: 'deepThinkCar'
        },
        { to: '/demo/control/telescope', key: 'demo-control-telescope', text: 'Telescope' },
        { to: '/demo/control/rumi-car', key: 'demo-control-rumi-car', text: 'RumiCar' },
        { to: '/demo/control/moth-car', key: 'demo-control-moth-car', text: 'MothCar' },
        { to: '/demo/control/lego-cobot', key: 'demo-control-lego-cobot', text: 'Lego Cobot' },
        // { to: '/demo/control/pick-drop-cobot', text: 'Pick & Drop Cobot' },
        // { to: '/demo/control/shoot-cobot', text: 'Shoot Cobot' },
        { to: '/demo/control/scout-mini', key: 'demo-control-scout-mini', text: 'Scout Mini' },
        { to: '/demo/control/hand-pi', key: 'demo-control-hand-pi', text: 'uHandPi' },
        {
          to: '/demo/control/video-keyboard-control',
          key: 'demo-control-video-keyboard-control',
          text: 'Video Keyboard Control'
        }
      ]
    },
    {
      to: '/demo/sample/broadcast/audio',
      key: 'demo-sample',
      text: translation('menu.demo_menu.sample'),
      children: [
        {
          to: '/demo/sample/broadcast/audio',
          key: 'demo-samples-broadcast',
          text: translation('menu.demo_menu.sample_menu.streaming'),
          children: [
            { to: '/demo/sample/broadcast/audio', key: 'demo-samples-audio', text: 'Audio' },
            { to: '/demo/sample/broadcast/video', key: 'demo-samples-video', text: 'Video' },
            { to: '/demo/sample/broadcast/media', key: 'demo-samples-media', text: 'Audio & Video' }
            // {
            //   to: '/demo/sample/broadcast/multiVideoPub',
            //   key: 'demo-samples-multi-video-pub',
            //   text: 'Multi Video Publish'
            // },
            // {
            //   to: '/demo/sample/broadcast/multiVideoSub',
            //   key: 'demo-samples-multi-video-sub',
            //   text: 'Multi Video Subscribe'
            // },
            // {
            //   to: '/demo/sample/broadcast/videoTime',
            //   key: 'demo-samples-video-time',
            //   text: 'Video Time'
            // }
          ]
        },
        {
          to: '/demo/sample/chat/messageChat',
          key: 'demo-samples-chat',
          text: translation('menu.demo_menu.sample_menu.chat'),
          children: [
            {
              to: '/demo/sample/chat/messageChat',
              key: 'demo-samples-message-chat',
              text: 'Message'
            },
            { to: '/demo/sample/chat/fileChat', key: 'demo-samples-file-chat', text: 'File' }
          ]
        },
        {
          to: '/demo/sample/control/keyboardControl',
          key: 'demo-samples-control',
          text: translation('menu.demo_menu.sample_menu.control_type'),
          children: [
            {
              to: '/demo/sample/control/keyboardControl',
              key: 'demo-samples-keyboard-control',
              text: 'Keyboard'
            },
            {
              to: '/demo/sample/control/gamepadControl',
              key: 'demo-samples-gamepad-control',
              text: 'Gamepad'
            },
            {
              to: '/demo/sample/control/speechControl',
              key: 'demo-samples-speech-control',
              text: 'Speech'
            },
            {
              to: '/demo/sample/control/handGestureControl',
              key: 'demo-samples-hand-gesture-control',
              text: 'Hand Gesture'
            },
            {
              to: '/demo/sample/control/handPoseControl',
              key: 'demo-samples-hand-pose-control',
              text: 'Hand Pose'
            },
            {
              to: '/demo/sample/control/faceDetectionControl',
              key: 'demo-samples-face-detection-control',
              text: 'Face Detection'
            }
          ]
        },
        {
          to: '/demo/sample/applications/imageCapture',
          key: 'demo-samples-applications',
          text: translation('menu.demo_menu.sample_menu.application'),
          children: [
            {
              to: '/demo/sample/applications/imageCapture',
              key: 'demo-samples-image-capture',
              text: 'Image Capture'
            },
            {
              to: '/demo/sample/applications/retryConnect',
              key: 'demo-samples-retry-connect',
              text: 'Retry Connect'
            },
            {
              to: '/demo/sample/applications/sensor',
              key: 'demo-samples-sensor',
              text: 'Sensor'
            },
            {
              to: '/demo/sample/applications/lidarVisualization',
              key: 'demo-samples-lidar-visualization',
              text: 'Lidar Visualization'
            },
            {
              to: '/demo/sample/applications/360Video',
              key: 'demo-samples-360-video',
              text: '360 Video'
            }
          ]
        }
      ]
    }
  ]
  return demoLinks
}

export const getProjectLinks = () => {
  const projectLinks: RouteLink[] = [
    {
      to: '/projects/co-drive',
      key: 'projects-codrive',
      text: translation('menu.project_menu.codrive'),

      children: [
        {
          to: '/projects/co-drive/simulator',
          key: 'projects-codrive-simulator',
          text: translation('menu.project_menu.codrive_menu.simulator')
        },
        {
          to: '/projects/co-drive/simulator-driver',
          key: 'projects-codrive-simulator-driver',
          text: translation('menu.project_menu.codrive_menu.simulator_driver')
        },
        {
          to: '/projects/co-drive/simulator-drone',
          key: 'projects-codrive-simulator-drone',
          text: translation('menu.project_menu.codrive_menu.simulator_drone')
        },
        {
          to: '/projects/co-drive/smart',
          key: 'projects-codrive-smart',
          text: translation('menu.project_menu.codrive_menu.smart')
        },
        {
          to: '/projects/co-drive/surround',
          key: 'projects-codrive-surround',
          text: translation('menu.project_menu.codrive_menu.surround')
        },
        {
          to: '/projects/co-drive/around',
          key: 'projects-codrive-around',
          text: translation('menu.project_menu.codrive_menu.around')
        },
        {
          to: '/projects/co-drive/360-control',
          key: 'projects-codrive-360-control',
          text: translation('menu.project_menu.codrive_menu.360_control')
        },
        {
          to: '/projects/co-drive/vslam',
          key: 'projects-codrive-vslam',
          text: translation('menu.project_menu.codrive_menu.vslam')
        }
      ]
    },
    {
      to: '/projects/ship',
      key: 'projects-ship',
      text: translation('menu.project_menu.ship'),
      children: [
        {
          to: '/projects/ship/ship-monitoring',
          key: 'projects-ship-monitoring',
          text: translation('menu.project_menu.ship_menu.ship_monitoring')
        },
        {
          to: '/projects/ship/maritime-monitoring',
          key: 'projects-maritime-monitoring',
          text: translation('menu.project_menu.ship_menu.maritime_monitoring')
        }
      ]
    }
  ]

  return projectLinks
}

export const getAILinks = () => {
  const AILinks: RouteLink[] = [
    {
      to: '/ai/language',
      key: 'ai-language',
      text: translation('menu.ai_menu.language'),
      children: [
        {
          to: '/ai/language/llm',
          key: 'ai-language-llm',
          text: translation('menu.ai_menu.language_menu.llm'),
          openInNewTab: true
        },
        {
          to: '/ai/language/vlm',
          key: 'ai-language-vlm',
          text: translation('menu.ai_menu.language_menu.vlm'),
          openInNewTab: true
        }
      ]
    },
    {
      to: '/ai/audio',
      key: 'ai-audio',
      text: translation('menu.ai_menu.audio'),
      children: [
        {
          to: '/ai/audio/asr',
          key: 'ai-audio-asr',
          text: translation('menu.ai_menu.audio_menu.asr'),
          openInNewTab: true
        },
        {
          to: '/ai/audio/tts',
          key: 'ai-audio-tts',
          text: translation('menu.ai_menu.audio_menu.tts'),
          openInNewTab: true
        }
      ]
    },
    {
      to: '/ai/vision',
      key: 'ai-vision',
      text: translation('menu.ai_menu.vision'),
      children: [
        {
          to: '/ai/vision/face-detection',
          key: 'ai-vision-face-detection',
          text: translation('menu.ai_menu.vision_menu.face_detection'),
          openInNewTab: true
        },
        {
          to: '/ai/vision/hand-gesture-recognition',
          key: 'ai-vision-hand-gesture-recognition',
          text: translation('menu.ai_menu.vision_menu.hand_gesture_recognition'),
          openInNewTab: true
        },
        {
          to: '/ai/vision/hand-landmark-detection',
          key: 'ai-vision-hand-landmark-detection',
          text: translation('menu.ai_menu.vision_menu.hand_landmark_detection'),
          openInNewTab: true
        },
        {
          to: '/ai/vision/object-detection',
          key: 'ai-vision-object-detection',
          text: translation('menu.ai_menu.vision_menu.object_detection'),
          openInNewTab: true
        },
        // {
        //   to: '/ai/vision/object-segmentation',
        //   key: 'ai-vision-object-segmentation',
        //   text: translation('menu.ai_menu.vision_menu.object_segmentation'),
        //   openInNewTab: true
        // },
        {
          to: '/ai/vision/depth-estimation',
          key: 'ai-vision-depth-estimation',
          text: translation('menu.ai_menu.vision_menu.depth_estimation'),
          openInNewTab: true
        },
        {
          to: '/ai/vision/analog-gauge-reading',
          key: 'ai-vision-analog-gauge-reading',
          text: translation('menu.ai_menu.vision_menu.analog_gauge_reading'),
          openInNewTab: true
        },
        {
          to: '/ai/vision/area-entry-detection',
          key: 'ai-vision-area-entry-detection',
          text: translation('menu.ai_menu.vision_menu.area_entry_detection'),
          openInNewTab: true
        }
      ]
    }
  ]
  return AILinks
}

export const getUsecaseLinks = () => {
  const usecaseLinks: RouteLink[] = [
    {
      to: '/usecase/smartPole',
      key: 'usecase-smartPole',
      text: translation('menu.usecase_menu.smart_pole'),
      children: [
        {
          to: '/usecase/smartPole/main',
          key: 'usecase-smartPole-main',
          text: translation('menu.usecase_menu.smart_pole_menu.smart_pole')
        },
        {
          to: '/usecase/smartPole/field',
          key: 'usecase-smartPole-field',
          text: translation('menu.usecase_menu.smart_pole_menu.smart_pole_field')
        }
      ]
    },
    {
      to: '/usecase/sensors',
      key: 'usecase-sensors',
      text: translation('menu.usecase_menu.visualization'),
      children: [
        {
          to: '/usecase/sensors/kanavi',
          key: 'usecase-sensors-kanavi',
          text: translation('menu.usecase_menu.visualization_menu.lidar')
        },
        {
          to: '/usecase/sensors/demo360',
          key: 'usecase-sensors-demo360',
          text: translation('menu.usecase_menu.visualization_menu.360_video')
        },
        {
          to: '/usecase/sensors/phoneRobot',
          key: 'usecase-sensors-phone-robot',
          text: 'Phone Robot'
        },
        {
          to: '/usecase/sensors/cctv',
          key: 'usecase-sensors-cctv',
          text: 'CCTV'
        }
      ]
    },
    {
      to: '/usecase/xr',
      key: 'usecase-xr',
      text: translation('menu.usecase_menu.xr'),
      children: [
        {
          to: '/usecase/xr/webxr-demo',
          key: 'usecase-xr-webxr-demo',
          text: 'Web XR'
        },
        {
          to: '/usecase/xr/scout-xr',
          key: 'usecase-xr-scout-xr',
          text: 'Scout XR'
        },
        {
          to: '/usecase/xr/so-arm-go2-xr',
          key: 'usecase-xr-so-arm-go2-xr',
          text: 'So-Arm XR'
        },
        {
          to: '/usecase/xr/a1-piperx-xr',
          key: 'usecase-xr-a1-piperx-xr',
          text: 'PiPER X XR'
        }
      ]
    }
  ]

  return usecaseLinks
}
